import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_purchase_order_list = createAsyncThunk("quotation", async (data) => {
  const body = new FormData();
  body.append("action","list");
  body.append("page", data?.page || 1);
  body.append("limit", data?.rows || 10);
  const response = await fetch(baseUrl + "purchase_order.php", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log("API Response:", res);
  return res;
});

export const get_all_purchaseorder_details = createAsyncThunk(
    "purchaseorder_details",
    async (id) => {
      const body = new FormData();
      body.append("action","list_by_id");
      body.append("id", id);
      const response = await fetch(baseUrl + "purchase_order.php", {
        method: "POST",
        body: body,
      });
      const res = await response.json();
      console.log(res);
      return res;
    }
  );
const initialState = {
  purchase_order_list: [],
  loading: false,
  all_purchaseorder_list: [],
  total_purchase_order_count: 0,
  error: null,
};

const purchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(get_purchase_order_list.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(get_purchase_order_list.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to fetch data";
    });
    builder.addCase(get_purchase_order_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      console.log("Redux received data:", data);
      
      if (data.success) {
        state.total_quotation_count = Number(data.totalcount) || 0;
        // Fix: It's "responselist" not "reponselist"
        state.purchase_order_list = data.data || [];
        console.log("Updated quotation_list:", state.purchase_order_list);
      } else {
        state.purchase_order_list = [];
        state. total_purchase_order_count = 0;
      }
    });

    builder.addCase(get_all_purchaseorder_details.pending, (state, action) => {
        state.all_loading = true;
      });
      builder.addCase(get_all_purchaseorder_details.rejected, (state, action) => {
        state.all_loading = false;
      });
      builder.addCase(get_all_purchaseorder_details.fulfilled, (state, action) => {
        state.all_loading = false;
        const res = action.payload;
        if (res.success) {
          state.all_purchaseorder_list = res.data || [];
        } else {
          state.all_purchaseorder_list = [];
        }
      });
  },
});

export default purchaseOrderSlice.reducer;